<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            default: 'default',
            validator: value => ['default', 'primary'].includes(value),
        },
    },
}
</script>

<template>
    <span
        class="shimmer-text"
        :class="[
            `shimmer-text--${variant}`,
            { 'shimmer-text-active': active },
        ]"
    >
        <slot />
    </span>
</template>

<style scoped lang="scss">
.shimmer-text {
    --shimmer-text-duration: 1.1s;
    --shimmer-text-highlight: rgba(255, 255, 255, .9);

    display: inline;
}

.shimmer-text--primary {
    --shimmer-text-duration: 1.4s;
    --shimmer-text-highlight: rgba(245, 128, 73, .9);

    display: inline-block;
}

.shimmer-text-active {
    animation: shimmer-text-wave var(--shimmer-text-duration) linear infinite;
    background-image: linear-gradient(
        100deg,
        currentColor 0%,
        currentColor 35%,
        var(--shimmer-text-highlight) 50%,
        currentColor 65%,
        currentColor 100%
    );
    background-clip: text;
    background-size: 220% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

@keyframes shimmer-text-wave {
    0% {
        background-position: 120% 0;
    }

    100% {
        background-position: -120% 0;
    }
}
</style>
